<template>
  <div>
    <h1 class="page-header">{{ $t('supplier.supplier') }}</h1>
    <ts-card>
      <ts-card-wrapper>
        <form class="form-horizontal">
          <div class="row">
            <div class="col-md-6 col-sm-12">
              <div class="row form-group  m-b-15">
                <label class="col-form-label col-md-3 required">{{
                  $t('supplier.code')
                }}</label>
                <div class="col-md-8">
                  <input
                    type="text"
                    v-model.trim="model.supplier_code"
                    class="form-control"
                    :class="{ 'is-invalid': errors.has('supplier_code') }"
                    :placeholder="$t('supplier.entersuppliercode')"
                  />
                  <div
                    class="invalid-feedback"
                    v-if="errors.has('supplier_code')"
                  >
                    {{ errors.first('supplier_code') }}
                  </div>
                </div>
              </div>
              <div class="row form-group  m-b-15">
                <label class="col-form-label col-md-3">{{
                  $t('supplier.nameKH')
                }}</label>
                <div class="col-md-8">
                  <input
                    type="text"
                    v-model.trim="model.supplier_name_kh"
                    class="form-control kh-font"
                    :class="{ 'is-invalid': errors.has('supplier_name_kh') }"
                    :placeholder="$t('supplier.enternameKH')"
                  />
                  <div
                    class="invalid-feedback"
                    v-if="errors.has('supplier_name_kh')"
                  >
                    {{ errors.first('supplier_name_kh') }}
                  </div>
                </div>
              </div>
              <div class="row form-group  m-b-15">
                <label class="col-form-label col-md-3 required">{{
                  $t('supplier.nameEN')
                }}</label>
                <div class="col-md-8">
                  <input
                    type="text"
                    v-model.trim="model.supplier_name_en"
                    class="form-control"
                    :class="{ 'is-invalid': errors.has('supplier_name_en') }"
                    :placeholder="$t('supplier.enternameEN')"
                  />
                  <div
                    class="invalid-feedback"
                    v-if="errors.has('supplier_name_en')"
                  >
                    {{ errors.first('supplier_name_en') }}
                  </div>
                </div>
              </div>
              <div class="row form-group  m-b-15">
                <label class="col-form-label col-md-3 required">{{
                  $t('supplier.tittleName')
                }}</label>
                <div class="col-md-8">
                  <input
                    type="text"
                    v-model.trim="model.contact_title"
                    class="form-control"
                    :class="{ 'is-invalid': errors.has('contact_title') }"
                    :placeholder="$t('supplier.enterMrorMs')"
                  />
                  <div
                    class="invalid-feedback"
                    v-if="errors.has('contact_title')"
                  >
                    {{ errors.first('contact_title') }}
                  </div>
                </div>
              </div>
              <div class="row form-group  m-b-15">
                <label class="col-form-label col-md-3 required">{{
                  $t('supplier.contactPerson')
                }}</label>
                <div class="col-md-8">
                  <input
                    type="text"
                    v-model.trim="model.contact_person"
                    class="form-control"
                    :class="{ 'is-invalid': errors.has('contact_person') }"
                    :placeholder="$t('supplier.enternamewhocancontact')"
                  />
                  <div
                    class="invalid-feedback"
                    v-if="errors.has('contact_person')"
                  >
                    {{ errors.first('contact_person') }}
                  </div>
                </div>
              </div>
              <div class="row form-group  m-b-15">
                <label class="col-form-label col-md-3 required">{{
                  $t('supplier.phoneNumber')
                }}</label>
                <div class="col-md-8">
                  <input
                    type="text"
                    v-model.trim="model.contact_phone_number"
                    class="form-control"
                    :class="{
                      'is-invalid': errors.has('contact_phone_number')
                    }"
                    :placeholder="$t('supplier.enterphonenumber')"
                  />
                  <div
                    class="invalid-feedback"
                    v-if="errors.has('contact_phone_number')"
                  >
                    {{ errors.first('contact_phone_number') }}
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6 col-sm-12">
              <div class="form-group row">
                <label class="col-form-label col-md-3 required">{{
                  $t('supplier.creditDay')
                }}</label>
                <div class="col-md-8">
                  <input
                    type="number"
                    min="0"
                    v-model.number="model.credit_day"
                    class="form-control"
                    :class="{ 'is-invalid': errors.has('credit_day') }"
                    :placeholder="$t('supplier.enteravailablenumbercreditday')"
                  />
                  <div class="invalid-feedback" v-if="errors.has('credit_day')">
                    {{ errors.first('credit_day') }}
                  </div>
                </div>
              </div>
              <div class="form-group row">
                <label class="col-form-label col-md-3 required">{{
                  $t('supplier.creditAmount')
                }}</label>
                <div class="col-md-8">
                  <input
                    type="number"
                    min="0"
                    v-model.number="model.credit_amount"
                    style="any"
                    class="form-control"
                    :class="{ 'is-invalid': errors.has('credit_amount') }"
                    :placeholder="$t('supplier.enteravailableamount')"
                  />
                  <div
                    class="invalid-feedback"
                    v-if="errors.has('credit_amount')"
                  >
                    {{ errors.first('credit_amount') }}
                  </div>
                </div>
              </div>
              <div class="form-group row">
                <label class="col-form-label col-md-3">{{
                  $t('supplier.emailAddress')
                }}</label>
                <div class="col-md-8">
                  <input
                    type="email"
                    v-model="model.supplier_email"
                    class="form-control"
                    :class="{ 'is-invalid': errors.has('supplier_email') }"
                    :placeholder="$t('supplier.entervalidemail')"
                  />
                  <div
                    class="invalid-feedback"
                    v-if="errors.has('supplier_email')"
                  >
                    {{ errors.first('supplier_email') }}
                  </div>
                </div>
              </div>
              <div class="form-group row">
                <label class="col-form-label col-md-3">{{
                  $t('supplier.address')
                }}</label>
                <div class="col-md-8">
                  <textarea
                    v-model="model.supplier_address"
                    class="form-control"
                    :class="{ 'is-invalid': errors.has('supplier_address') }"
                    :placeholder="$t('supplier.entersupplieraddress')"
                  ></textarea>
                  <div
                    class="invalid-feedback"
                    v-if="errors.has('supplier_address')"
                  >
                    {{ errors.first('supplier_address') }}
                  </div>
                </div>
              </div>
              <div class="form-group row">
                <label class="col-form-label col-md-3">{{
                  $t('supplier.description')
                }}</label>
                <div class="col-md-8">
                  <textarea
                    v-model="model.supplier_description"
                    class="form-control"
                    rows="3"
                    :class="{
                      'is-invalid': errors.has('supplier_description')
                    }"
                    :placeholder="$t('supplier.leaveyourdescriptionhere')"
                  ></textarea>
                  <div
                    class="invalid-feedback"
                    v-if="errors.has('supplier_description')"
                  >
                    {{ errors.first('supplier_description') }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12 text-right">
              <ts-button
                class="btn-primary mr-2"
                :waiting="waiting"
                @click.prevent="store"
                >{{ $t('save') }}</ts-button
              >
              <ts-button class="btn-default" @click="cancel">{{
                $t('cancel')
              }}</ts-button>
            </div>
          </div>
        </form>
      </ts-card-wrapper>
    </ts-card>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'

export default {
  name: 'supplier-create',
  data() {
    return {
      model: {
        supplier_code: '',
        supplier_name_kh: '',
        supplier_name_en: '',
        contact_title: '',
        contact_person: '',
        contact_phone_number: '',
        supplier_phone_number: '',
        credit_day: '',
        credit_amount: '',
        supplier_email: '',
        supplier_address: '',
        supplier_description: ''
      },
      errors: new Errors(),
      waiting: false
    }
  },
  methods: {
    store() {
      this.errors = new Errors()
      this.waiting = true
      this.$store
        .dispatch('supplier/store', this.model)
        .then(response => {
          this.$toasted.success(response.message)
          this.$router.push({ name: 'supplier' })
          this.waiting = false
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.waiting = false
          this.errors = new Errors(error.errors)
        })
    },
    cancel() {
      this.$router.push({ name: 'supplier' })
    }
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('supplier/RESET_STATE')
    next()
  }
}
</script>
